import { FormattedMessage } from 'react-intl';

export default function FrontBrands() {
  return (
    <section className="py-6 py-md-8 border-bottom">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay={100}>
            <div className="card card-border border-primary shadow-lg mb-6 mb-md-8 lift lift-lg">
              <div className="card-body text-center">
                <div className="icon-circle bg-primary text-white mb-5">
                  <i className="fe fe-users" />
                </div>
                <h4 className="fw-bold">
                  <FormattedMessage id="provinces" />
                </h4>
                <p className="text-gray-700 mb-5">7</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay={100}>
            <div className="card card-border border-success shadow-lg mb-6 mb-md-8 lift lift-lg">
              <div className="card-body text-center">
                <div className="icon-circle bg-success text-white mb-5">
                  <i className="fe fe-clock" />
                </div>
                <h4 className="fw-bold">
                  <FormattedMessage id="local_levels" />
                </h4>
                <p className="text-gray-700 mb-5">753</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay={100}>
            <div className="card card-border border-warning shadow-lg mb-6 mb-md-8 lift lift-lg">
              <div className="card-body text-center">
                <div className="icon-circle bg-warning text-white mb-5">
                  <i className="fe fe-users" />
                </div>
                <h4 className="fw-bold">
                  <FormattedMessage id="participants" />
                </h4>
                <p className="text-gray-700 mb-5">21000+</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay={100}>
            <div className="card card-border border-warning shadow-lg mb-6 mb-md-8 lift lift-lg">
              <div className="card-body text-center">
                <div className="icon-circle bg-warning text-white mb-5">
                  <i className="fe fe-users" />
                </div>
                <h4 className="fw-bold">
                  <FormattedMessage id="resource_persons" />
                </h4>
                <p className="text-gray-700 mb-5">1200+</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
